"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICEBREAKER_GENRES = exports.HOT_TAKE_GENRES = void 0;
const DEFAULT_GENRES = ["funny", "spicy", "normal"];
exports.HOT_TAKE_GENRES = DEFAULT_GENRES;
exports.ICEBREAKER_GENRES = DEFAULT_GENRES;
//# sourceMappingURL=llmConstants.js.map